import './nav-mobile-menu.css';
import { useCallback, useEffect, useState } from 'react';
import { FloatButton, message } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { licenseModuleBase } from '@/extensions';
import { serverFetch } from '@/server';
import { subscribeCompanyRefresh } from '@/services/companyRefreshService';

const NavMobileMenu = () => {
  const navigate = useNavigate();
  const [company, setCompany] = useState();
  const user = useSelector((s) => s.user);
  const activeLicenseModules = company?.activeLicense?.activeModules;

  const loadCompany = useCallback(() => {
    serverFetch(`company/current`)
      .then(data => setCompany(data))
      .catch(e => message.error(e.userMessage));
  }, []);

  useEffect(() => {
    loadCompany();
  }, [loadCompany])

  useEffect(() => subscribeCompanyRefresh(loadCompany), [loadCompany])

  const menuItems = [];

  const getItem = (label, key, urlTo, img, onClick, disabled = false, tooltip = null, id = '', external = false, badgeCount = 0) => {
    return { key, label, url: urlTo, img, onClick, disabled, tooltip, id, external, badgeCount };
  };


  if (licenseModuleBase(activeLicenseModules)) {
    menuItems.push(
      getItem('Оплаты', 'payments', '/payments', 'card.svg', null, false, null, 'payments'),
      user.isAdmin && getItem('Реестры', 'reestrs', '/reestrs', 'reestr.svg', null, false, null, 'reestrs'),
      getItem('Продажи', 'sales', '/sales', 'sale2.svg', null, false, null, 'sales'),
      getItem('Склад', 'stock', '/stock', 'stock.svg', null, false, null, 'stock'),
      getItem('Отчеты', 'reports', '/reports', 'print.svg', null, false, null, 'reports'),


      user.isAdmin && getItem('Лицензии', 'license', '/license', 'key.svg', null, false, null, 'licenses'),
      user.isAdmin && getItem('Настройки', 'settings', '/settings', 'settings.svg', null, false, null, 'settings'),

      // getItem('Сообщения', 'messages', '/messages', 'mail.svg', null, false, null, 'messages'),
    );
    // licenseModuleMessages(activeLicenseModules) && hiddenItems.push(
    //   getItem('Сообщения', 'messages', '/messages', 'mail.svg', null, false, null, 'messages'),
    // );
  }

  if (user.isSuperadmin) {
    menuItems.push(getItem('Компании', 'companies', '/companies', 'monitor.svg', null, false, null, 'companies'));
  }

  menuItems.push(getItem('Помощь', 'help', 'https://kb.sport24.cloud/', 'help.svg', null, false, 'База знаний', 'help', true));

  if (menuItems.length === 0)
    return null;

  return (
    <FloatButton.Group 
      trigger="click" 
      icon={<img src="/images/mobile-menu.svg" alt="fav" className="nav-mobile-menu-icon"/>}
    >
      {menuItems.filter(Boolean).map((item, index) => {
        const handleClick = () => {
          if (item.external && item.url) {
            window.open(item.url, '_blank', 'noopener,noreferrer');
          } else if (item.url) {
            navigate(item.url);
          } else if (item.onClick) {
            item.onClick();
          }
        };

        // Позиционирование: кнопки раскрываются вверх от главной кнопки в обратном порядке
        // Расстояние между кнопками: 8px
        // Высота кнопки: ~56px, отступ: 8px
        // Позиция = (menuItems.length - index) * (56 + 8) = (menuItems.length - index) * 64
        // Последний элемент массива ближе к главной кнопке, первый - дальше
        const buttonHeight = 56;
        const spacing = 8;
        const buttonStyle = { insetBlockEnd: (menuItems.length - index) * (buttonHeight + spacing) };

        return (
          <FloatButton
            key={item.key}
            style={buttonStyle}
            icon={
              <span className="nav-mobile-menu-item-icon-wrap">
                <img src={`/images/${item.img}`} alt={item.label} className="nav-mobile-menu-item-icon"/>
                {item.badgeCount > 0 ? <span className="nav-mobile-menu-badge">{item.badgeCount}</span> : null}
              </span>
            }
            onClick={handleClick}
            tooltip={item.tooltip || item.label}
          />
        );
      })}
    </FloatButton.Group>
  );
};

export default NavMobileMenu;
